// removed by extract-text-webpack-plugin
module.exports = {"rootTouchBuffer":"Handle__rootTouchBuffer__2KEpN","visibleHandle":"Handle__visibleHandle__hnQL8","dragged":"Handle__dragged__1bEm4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RangeSlider/Handle.css
// module id = 2068
// module chunks = 0